import { createFileRoute } from '@tanstack/react-router'
import SettingsOrganizationSlackConnectionsPage from '@/components/pages/Settings/organization/SettingsOrganizationSlackConnectionsPage/SettingsOrganizationSlackConnectionsPage'
import z from 'zod/v4'

const searchSchema = z.object({
  status: z.enum(['success', 'failure']).optional(),
  error_code: z.enum(['om1', 'se2', 'cc3']).optional(),
  team_name: z.string().optional(),
})

export const Route = createFileRoute(
  '/$workspaceName/$environment/organization-settings/slack-connections',
)({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  return <SettingsOrganizationSlackConnectionsPage />
}
